'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onStripeLoaded = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.loadScript = loadScript;
exports.loadStripe = loadStripe;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadScript(src, async) {
    var scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.type = 'text/javascript';
    scriptTag.async = async;

    return new _promise2.default(function (resolve, reject) {
        scriptTag.onload = resolve;
        document.head.appendChild(scriptTag);
    });
}

var stripePromise = false;
function loadStripe(key) {
    if (!stripePromise) {
        stripePromise = loadScript('https://js.stripe.com/v2/', true).then(function () {
            window.Stripe.setPublishableKey(key);
        });
    }

    return stripePromise;
}

var onStripeLoaded = exports.onStripeLoaded = function onStripeLoaded() {
    return stripePromise || _promise2.default.reject(new Error('loadStripe was never invoked - this is likely a race condition'));
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/script.js
// module id = GVls
// module chunks = 60